// Shared styles and Bootstrap behavior for all five pages.
import './styles.scss'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/offcanvas'
import Popover from 'bootstrap/js/dist/popover'
import Tooltip from 'bootstrap/js/dist/tooltip'

document.querySelectorAll('[data-bs-toggle="popover"]').forEach(element => {
    Popover.getOrCreateInstance(element)
})

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(element => {
    Tooltip.getOrCreateInstance(element)
})
